import React, { useState } from 'react'

// components
import Header from '../../Universal/Header/Header';
import HiddenHeader from '../../Universal/HiddenHeader/HiddenHeader';
import Bigpage from './Bigpage/Bigpage';
import About from './About/About';
import Tools from './Tools/Tools';
import News from './News/News';
import Founder from './Founder/Founder';
import Partners from './Partners/Partners';
import Footer from '../../Universal/Footer/Footer';

// modals
import Bio from '../Modals/Bio/Bio';
import Details from '../Modals/Details/Details';

const IndexPage = () => {
  const [bioModalState, setBioModalState] = useState(false);

  const [detailsModalState, setDetailsModalState] = useState({
    title: 'title',
    text: 'text',
    active: false
  })

  return (
    <section>
      <Header />
      <HiddenHeader />
      <Bigpage />
      <About />
      <Tools setDetailsModalState={setDetailsModalState} />
      <News />
      <Founder setBioModalState={setBioModalState} />
      <Partners />
      <Footer />

      {
        bioModalState ? 
          <Bio bioModalState={bioModalState} setBioModalState={setBioModalState} />
        :
        <></>
      }


      {
        detailsModalState.active ?  
          <Details title={detailsModalState.title} text={detailsModalState.text} setDetailsModalState={setDetailsModalState} /> 
        :
        <></>
      }
    </section>
  )
}

export default React.memo(IndexPage);
